import React from 'react';
import PropTypes from 'prop-types';
import Api, { Utils } from '../../Api';
import Flyout from './flyout';

import Bag from '../../images/icons/purse.svg';

import './style.less';

export default class Cart extends React.Component {
  constructor() {
    super();

    Utils.bindThis(
      this,
      [
        'cartUpdated',
        'cartToggle',
        'submitOrder',
        'cartFlyout'
      ]
    );
    this.cartUpdated = this.cartUpdated.bind(this);

    this.state = {
      cart: null,
      visible: false,
      user: Api.cache.getUser(),
      currentRetailer: null
    };
  }

  cartUpdated() {
    Api.getCart(true).then((response) => {
      this.setState({ cart: response });
    });
  }

  componentWillMount() {
    Api.cache.addChangeListener(this.cartUpdated, Api.cache.eventTypes.CART_CHANGED);
    Api.startListen(this, 'currentRetailer', Api.cache.eventTypes.RETAILER_CHANGED);
    Api.startListen(this, 'visible', Api.cache.eventTypes.CART_VISIBLE_CHANGED);
    Api.userStartListen(this, 'user');
    Api.getCart();
  }

  componentWillUnmount() {
    Api.cache.removeChangeListener(this.cartUpdated, Api.cache.eventTypes.CART_CHANGED);
    Api.stopListen(this, Api.cache.eventTypes.RETAILER_CHANGED);
    Api.stopListen(this, Api.cache.eventTypes.CART_VISIBLE_CHANGED);
    Api.userStopListen(this);
  }

  cartToggle() {
    Api.cache.setCartVisible(!this.state.visible);
  }

  submitOrder() {
    let user = this.state.user;

    Api.cache.setCartVisible(false);

    if (!user) {
      // No user: Goes to checkout.
      this.context.router.push('/checkout');
    } else if (window.linkInstruments) {
      // We need to link instruments.
      if (user.instruments.length > 0) {
        // We already have instruments!
        this.context.router.push('/checkout/delivery');
      } else {
        this.context.router.push('/checkout/payment');
      }
    } else {
      // We do not need to link instruments. Go to delivery.
      this.context.router.push('/checkout/delivery');
    }
  }

  cartFlyout() {
    if (!this.state.visible) return null;

    return (
      <Flyout
        subtotal={true}
        cart={this.state.cart}
        enableCheckout={this.state.user && this.state.user.impersonating}
        retailerToken={this.state.currentRetailer ? this.state.currentRetailer.token : null}
        checkout={this.submitOrder}
        closeCart={this.cartToggle} />
    );
  }

  render() {
    let cartText = null;
    if (this.state.cart && this.state.cart.cart.items.length > 0) {
      cartText = <span className="amount">{this.state.cart.cart.items.length > 9 ? '+' : this.state.cart.cart.items.length}</span>;
    }

    let cartComponentClass = 'cart-component' + (this.state.visible ? ' opened' : '');

    return(
      <div className={cartComponentClass}>
        <div className="cart-label" onClick={this.cartToggle}>
          <div><img role="presentation" src={Bag} /></div>
          {cartText}     
        </div>
        <div className="cart-fullscreen" onClick={this.cartToggle} />
        {this.cartFlyout()}
      </div>
    );
  }
}

Cart.contextTypes = {
  router: PropTypes.object
};



/** WEBPACK FOOTER **
 ** ./src/components/Cart/index.js
 **/